var _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImgSpiritualPerson(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#FFEADB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4_21407",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 100,
    height: 100
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "#D6E8F6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4_21407)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.505 83.8907H32.2728C26.6919 81.6128 21.6147 78.2575 17.3311 74.0166C17.5921 57.4015 35.9518 67.0382 40.2836 55.1584C41.0517 52.5399 41.1658 49.773 40.6159 47.1001L49.4694 47.2781L58.3229 47.1001C57.7612 49.772 57.8755 52.5418 58.6552 55.1584C62.9752 67.0264 81.3349 57.354 81.6078 74.0166C77.3326 78.2566 72.2632 81.612 66.6898 83.8907H49.505Z",
    fill: "#D7AE88"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.7299 52.4767H49.5874C48.3047 52.6042 47.0096 52.4544 45.7897 52.0376C44.8166 51.6223 44.3418 50.661 43.0008 49.3673C41.814 48.2636 39.8083 47.148 39.298 45.9494C38.6927 44.4896 38.8351 42.8993 38.5859 40.775C37.5178 41.3565 36.3903 38.3302 36.2123 37.3333C35.88 35.8616 34.8237 33.3694 34.4914 31.696C34.3015 30.7347 34.4202 29.9751 34.7406 29.7259C35.4408 29.2037 36.1767 29.5123 37.2448 31.0077C37.1215 29.1905 37.1811 27.3655 37.4228 25.5603C38.8826 17.1696 59.3904 12.5055 61.6928 25.5603C61.9225 27.3665 61.9821 29.1903 61.8708 31.0077C62.9389 29.5479 63.651 29.2393 64.363 29.7615C64.6835 30.0107 64.8021 30.7703 64.6123 31.7316C64.28 33.405 63.2237 35.8972 62.8914 37.3689C62.6659 38.3539 61.5503 41.3328 60.5178 40.8343C60.2804 42.8875 60.411 44.3947 59.8176 45.8663C59.3191 47.0531 57.2897 48.2399 56.1504 49.3199C54.8212 50.6372 54.3465 51.5867 53.3733 52.0258C52.2052 52.4354 50.9626 52.5892 49.7299 52.4767Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.188 23.4593C38.4552 25.5362 38.028 33.6658 38.1585 36.5141C35.2153 25.8329 33.6368 18.2375 40.0099 13.4428C48.3887 7.14093 57.8118 11.0692 59.3309 13.609C65.4785 17.0032 63.3423 26.5687 61.4909 34.9712C61.1111 30.1327 60.1753 25.3541 58.7019 20.7297C54.0141 17.7271 44.6028 18.3087 40.188 23.4593Z",
    fill: "#312C36"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7422 56.2851C48.3022 56.8796 50.967 56.8551 53.5157 56.2139L53.3258 61.4595C53.3258 61.4595 49.6942 63.8331 49.5162 63.8331C49.3382 63.8331 45.9558 61.6138 45.9558 61.6138L45.7422 56.2851Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.5049 56.6547C50.8578 56.6612 52.206 56.4936 53.5163 56.1562L53.3264 61.4019C53.3264 61.4019 49.6948 63.7755 49.5168 63.7755L49.5049 56.6547Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.597 56.4637L46.336 56.3687L39.0728 54.4224L38.7998 56.6179C34.4799 60.4394 26.9319 59.9766 21.0691 63.086C17.6037 64.9374 16.4999 67.2397 14.9927 71.5834L4.07422 102.855H82.7112C82.545 92.376 84.8711 71.5834 81.916 67.2516C76.4805 59.2645 65.7994 61.5906 60.2096 56.6298L59.9366 54.4342C58.6549 54.5173 53.9314 57.9946 52.6615 58.1133C52.5749 58.1017 52.4871 58.1017 52.4005 58.1133V60.7361H46.597V56.4637Z",
    fill: "#4F4F4F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.4481 56.4637L52.7092 56.3687L59.9843 54.4224L60.2572 56.6179C64.5653 60.4394 72.1252 59.9766 77.9761 63.086C81.4415 64.9374 82.5453 67.2397 84.0644 71.5834L94.971 102.855H49.5049V60.7598H52.4481V56.4637Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.6435 80.6743L20.3447 102.855H24.5935L27.6435 80.6743Z",
    fill: "#292929"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M71.3535 80.6743L78.6523 102.855H74.4036L71.3535 80.6743Z",
    fill: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 73.8379L49.2762 63.9995L63 96.1612L41.7239 106L28 73.8379Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.8446 75.5944L42.6851 74.2932L43.8557 76.8483L46.5247 75.6256L47.8714 78.5653L45.2024 79.788L47.6829 85.2029L44.8424 86.5042L42.3619 81.0893L39.6891 82.3137L38.3424 79.374L41.0151 78.1496L39.8446 75.5944Z",
    fill: "#FFB1B6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3152 92.9582L47.7012 92.4361C43.4406 92.4361 40.9246 92.5429 36.7708 91.5222C35.857 91.2967 35.1449 90.9407 34.2786 91.5222C33.4122 92.1038 33.2816 93.3618 34.777 94.2162C34.5309 94.3639 34.332 94.5787 34.2038 94.8355C34.0756 95.0924 34.0233 95.3804 34.0533 95.6659C34.0832 95.9514 34.194 96.2224 34.3727 96.447C34.5513 96.6716 34.7904 96.8406 35.0619 96.934C34.3617 97.9072 34.599 99.1058 36.3792 99.8298C35.05 100.269 35.5484 101.325 36.581 101.895C37.7399 102.478 38.9283 103.001 40.1413 103.461C43.2025 103.48 46.2472 103.012 49.161 102.073L50.5733 95.5455L49.3152 92.9582Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3145 93.2783C47.7242 92.2339 47.3326 90.0502 46.4069 88.4599C45.7304 87.2731 45.0183 87.1663 42.6685 85.6591C41.7203 84.821 40.8209 83.9294 39.9744 82.9888C36.9718 86.3949 43.1669 87.3443 42.1819 90.1095C41.9326 90.8335 41.1019 91.3794 40.0456 92.3644L42.2175 94.0734L49.3145 93.2783Z",
    fill: "#EFD1B4"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M48.9941 90.7979L86.6986 93.2901C97.6645 93.9429 98.2936 107.674 86.5206 106.974L48.9941 104.493V90.7979Z",
    fill: "#292929"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgSpiritualPerson);
export default __webpack_public_path__ + "static/media/imgSpiritualPerson.3d7c49a0188441ed998fd511e3ccd1b2.svg";
export { ForwardRef as ReactComponent };